import { NgModule } from '@angular/core';
import { SecuredImageU2bComponent } from '@shared/components/secured-image-u2b/secured-image-u2b.component';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    declarations: [SecuredImageU2bComponent],
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
    ],
    exports: [SecuredImageU2bComponent],
})
export class SecuredImageU2bModule {}
